import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const ServicesDropdown: React.FC = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCoursesClick = () => {
    setOpen(false);
    navigate("/services");
  };

  const handleInsuranceClick = () => {
    setOpen(false);
    navigate("/insurance");
  };

  return (
    <div className="services-dropdown" ref={dropdownRef}>
      <button
        type="button"
        className="services-dropdown-trigger"
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="services-label">Services</span>
        <i className={`ri-arrow-down-s-line services-chevron ${open ? "open" : ""}`} />
      </button>

      {open && (
        <div className="services-dropdown-menu">
          <button type="button" className="services-dropdown-item" onClick={handleCoursesClick}>
            Courses
          </button>
          <button type="button" className="services-dropdown-item" onClick={handleInsuranceClick}>
            Insurance
          </button>
        </div>
      )}
    </div>
  );
};

export default ServicesDropdown;


